import { useEffect } from 'react';

export const emitCustomEvent = <T = any>(eventName: string, detail?: any) => {
  const event = new CustomEvent<T>(eventName, { detail });
  window.dispatchEvent(event);
};

export const useCustomEventListener = <T = any>(
  eventName: string,
  callback: (event: CustomEvent<T>) => void,
) => {
  useEffect(() => {
    const handler = (event: Event) => {
      if (event instanceof CustomEvent) {
        callback(event);
      }
    };

    window.addEventListener(eventName, handler);

    return () => {
      window.removeEventListener(eventName, handler);
    };
  }, [eventName, callback]);
};
